import React, { createContext, useState, useMemo } from 'react'

interface orgDataStruct {
    availability: any[],
    setAvailability: React.Dispatch<React.SetStateAction<any[]>>,
    customAvailability: any[],
    setCustomAvailability: React.Dispatch<React.SetStateAction<any[]>>,
    calendarInfoData: any,
    setCalendarInfoData: React.Dispatch<React.SetStateAction<any>>
    appointmentInfoData: any,
    setAppointmentInfoData: React.Dispatch<React.SetStateAction<any>>
    myAppointments: any[],
    setMyAppointments: React.Dispatch<React.SetStateAction<any>>,
    organizationGroups: any[],
    setOrganizationGroups: React.Dispatch<React.SetStateAction<any[]>>,
    saveEvent: any,
    setSaveEvent: React.Dispatch<React.SetStateAction<any>>,
    selectedGroups: any[],
    setSelectedGroups: React.Dispatch<React.SetStateAction<any[]>>,
    syncEvent: any,
    setSyncEvent: React.Dispatch<React.SetStateAction<any>>,
    orgContextData: any,
    setOrgContextData: React.Dispatch<React.SetStateAction<any>>,
}
const orgData = {
    availability: [],
    setAvailability: (d: any[]) => {},
    customAvailability: [],
    setCustomAvailability: (d: any[]) => {},
    calendarInfoData: {},
    setCalendarInfoData: (d: any) => {},
    myAppointments: [],
    setMyAppointments: (d: any) => {},
    appointmentInfoData: [],
    setAppointmentInfoData: (d: any) => {},
    organizationGroups: [],
    setOrganizationGroups: (d: any[]) => {},
    saveEvent: {},
    setSaveEvent: (d: any) => {},
    selectedGroups: [],
    setSelectedGroups: (d: any[]) => {},
    syncEvent: {},
    setSyncEvent: (d: any) => {},
    orgContextData: {},
    setOrgContextData: (d: any) => {},
} as orgDataStruct

const OrgContext = createContext(orgData);

const OrgProvider = (props: any) => {

    const [availability, setAvailability] = useState<any[]>([])
    const [customAvailability, setCustomAvailability] = useState<any[]>([])
    const [calendarInfoData, setCalendarInfoData] = useState<any>()
    const [myAppointments, setMyAppointments] = useState<any[]>([])
    const [appointmentInfoData, setAppointmentInfoData] = useState<any>()
    const [organizationGroups, setOrganizationGroups] = useState<any[]>([])
    const [saveEvent, setSaveEvent] = useState<any>(Date.now())
    const [selectedGroups, setSelectedGroups] = useState<any[]>([])
    const [syncEvent, setSyncEvent] = useState<any>(Date.now())
    const [orgContextData, setOrgContextData] = useState<any>(Date.now())


    return <OrgContext.Provider value={
        {
            availability, 
            setAvailability,
            customAvailability,
            setCustomAvailability,
            calendarInfoData,
            setCalendarInfoData,
            myAppointments,
            setMyAppointments,
            appointmentInfoData,
            setAppointmentInfoData,
            organizationGroups,
            setOrganizationGroups,
            selectedGroups,
            setSelectedGroups,
            saveEvent,
            setSaveEvent,
            syncEvent,
            setSyncEvent,
            orgContextData,
            setOrgContextData
        }
    }>{props.children}</OrgContext.Provider>;
};

const Consumer = OrgContext.Consumer
export { OrgContext, OrgProvider, Consumer };

